'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwRoute = require('../../components/cwrouter/CwRoute');

var _CwRoute2 = _interopRequireDefault(_CwRoute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type {React.StatelessComponent} */
var Tab = function Tab(props) {
  return _react2.default.createElement(_CwRoute2.default, { id: props.id, children: props.children });
};

Tab.propTypes = {
  id: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.element.isRequired
};

exports.default = Tab;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/tabpanel/Tab.js
// module id = 763
// module chunks = 10